import { TApplicationState } from 'shared/types/redux';

export const breadcrumbsSelector = (state: TApplicationState) => {
  return state.newbuilding.breadcrumbs;
};
